module.exports = __webpack_public_path__ + "static/media/varie7.68b2a3a4.jpg";